<template>
  <div class="score-info">
    <div>
      <span>得分</span>
      <span class="score-info-value">{{ currentAnswerData.score }}</span>
      <span>满分 {{ currentAnswerData.surveyTotalScore }} 分</span>
    </div>
    <section class="line-wrapper">
      <div class="line"></div>
    </section>
    <div>
      <span>答对</span>
      <span class="score-info-value">{{ currentAnswerData.scoreQuestionNum }}</span>
      <span>共 {{ currentAnswerData.surveyTotalScoreQuestionNum }} 道</span>
    </div>
    <section class="line-wrapper">
      <div class="line"></div>
    </section>
    <div>
      <span>答题时长</span>
      <span class="score-info-value">{{ formatSeconds }}</span>
    </div>
  </div>
</template>

<script>
import { secondToTime } from 'dygc'

export default {
  name: 'ScoreInfo',
  computed: {
    currentAnswerData() {
      return this.$bus.currentAnswerData || {}
    },
    formatSeconds() {
      return secondToTime(this.currentAnswerData.surveyDuration, ['时', '分', '秒'])
    }
  }
}
</script>

<style scoped lang="scss">
.score-info {
  display: flex;
  color: rgba(0, 0, 0, 0.45);

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .score-info-value {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.65);
    font-family: DINAlternate, PingFangSC-Regular, serif;
    font-weight: 700;
  }

  .line-wrapper {
    padding: 10px 0;
    margin: 0 10px;
    .line {
      width: 1px;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
}
</style>
